const cs = {
    lengthMenu: 'Zobrazit _MENU_ záznamů',
    zeroRecords: 'Žádné záznamy nebyly nalezeny',
    infoEmpty: 'Žádné záznamy k zobrazení',
    search: '',
    emptyTable: 'Tabulka neobsahuje žádná data',
    infoThousands: ' ',
    loadingRecords: 'Načítání...',
    paginate: {
        first: 'První',
        last: 'Poslední',
        next: 'Další',
        previous: 'Předchozí',
    },
    aria: {
        sortAscending: ': aktivujte pro řazení sloupce vzestupně',
        sortDescending: ': aktivujte pro řazení sloupce sestupně',
    },
    autoFill: {
        fill: 'Vyplnit všechny buňky <i>%d</i>',
        fillHorizontal: 'Vyplnit buňky horizontálně',
        fillVertical: 'Vyplnit buňky vertikálně',
        cancel: 'Zrušit',
        info: 'Informace',
    },
    buttons: {
        colvis: 'Viditelnost sloupců',
        colvisRestore: 'Obnovit viditelnost',
        copy: 'Kopírovat',
        copySuccess: {
            1: '1 řádek zkopírován do schránky',
            _: '%ds řádků zkopírováno do schránky',
        },
        copyTitle: 'Kopírovat do schránky',
        csv: 'CSV',
        excel: 'Excel',
        pageLength: {
            '-1': 'Zobrazit všechny řádky',
            _: 'Zobrazit %d řádků',
            1: 'Zobrazit 1 řádek',
        },
        pdf: 'PDF',
        print: 'Tisk',
        copyKeys:
            'Stiskněte ctrl nebo u2318 + C pro zkopírování dat tabulky do schránky. Pro zrušení klikněte sem nebo stiskněte escape.',
        collection: 'Kolekce',
    },
    processing: 'Zpracování...',
    decimal: ',',
    searchBuilder: {
        add: 'Přidat',
        clearAll: 'Vymazat vše',
        condition: 'Podmínka',
        data: 'Data',
        deleteTitle: 'Smazat',
        value: 'Hodnota',
        conditions: {
            date: {
                after: 'Po',
                before: 'Před',
                between: 'Mezi',
                empty: 'Prázdné',
                equals: 'Rovno',
                not: 'Ne',
                notBetween: 'Není mezi',
                notEmpty: 'Není prázdné',
            },
            number: {
                between: 'Mezi',
                empty: 'Prázdné',
                equals: 'Rovno',
                gt: 'Větší než',
                gte: 'Větší nebo rovno',
                lt: 'Menší než',
                lte: 'Menší nebo rovno',
                not: 'Ne',
                notBetween: 'Není mezi',
                notEmpty: 'Není prázdné',
            },
            string: {
                contains: 'Obsahuje',
                empty: 'Prázdné',
                endsWith: 'Končí na',
                equals: 'Rovno',
                not: 'Ne',
                notEmpty: 'Není prázdné',
                startsWith: 'Začíná na',
            },
            array: {
                equals: 'Rovno',
                empty: 'Prázdné',
                contains: 'Obsahuje',
                not: 'Ne',
                notEmpty: 'Není prázdné',
                without: 'Bez',
            },
        },
        logicAnd: 'A',
        logicOr: 'Nebo',
        button: {
            0: 'Vyhledávací nástroj',
            _: 'Vyhledávací nástroj (%d)',
        },
        leftTitle: 'Odlišná kritéria',
        rightTitle: 'Odsadit kritéria',
        title: {
            0: 'Vyhledávací nástroj',
            _: 'Vyhledávací nástroj (%d)',
        },
    },
    searchPanes: {
        clearMessage: 'Vymazat vše',
        collapse: {
            0: 'Vyhledávací panely',
            _: 'Vyhledávací panely (%d)',
        },
        count: '{total}',
        countFiltered: '{shown} ({total})',
        emptyPanes: 'Žádné vyhledávací panely',
        loadMessage: 'Načítání vyhledávacích panelů...',
        title: '%d filtrů aktivních',
    },
    select: {
        1: '%d řádek vybrán',
        _: '%d řádků vybráno',
        cells: {
            1: '1 buňka vybrána',
            _: '%d buněk vybráno',
        },
        columns: {
            1: '1 sloupec vybrán',
            _: '%d sloupců vybráno',
        },
        rows: {
            0: '%d řádků vybráno',
            1: '1 řádek vybrán',
            _: '%d řádků vybráno',
        },
        0: 'Žádný řádek nevybrán',
        2: '%d řádky vybrány',
    },
    thousands: ' ',
    searchPlaceholder: 'Hledat...',
    info: '_START_ až _END_ z _TOTAL_ záznamů',
    infoFiltered: ' (filtrováno z _MAX_ záznamů)',
    datetime: {
        previous: 'Předchozí',
        next: 'Další',
        hours: 'Hodiny',
        minutes: 'Minuty',
        seconds: 'Sekundy',
        unknown: 'Neznámé',
        amPm: ['dop.', 'odp.'],
    },
    editor: {
        close: 'Zavřít',
        create: {
            button: 'Nový',
            title: 'Přidat nový záznam',
            submit: 'Přidat',
        },
        edit: {
            button: 'Upravit',
            title: 'Upravit záznam',
            submit: 'Upravit',
        },
        remove: {
            button: 'Smazat',
            title: 'Smazat',
            submit: 'Smazat',
            confirm: {
                _: 'Opravdu chcete smazat %d řádků?',
                1: 'Opravdu chcete smazat 1 řádek?',
            },
        },
        error: {
            system: 'Došlo k chybě',
        },
        multi: {
            title: 'Více hodnot',
            info: 'Vybrané položky obsahují různé hodnoty pro tento vstup. Pro úpravu a nastavení všech položek na stejnou hodnotu klikněte nebo klepněte zde, jinak si zachovají své individuální hodnoty.',
            restore: 'Vrátit změny',
            noMulti: 'Tento vstup lze upravovat jednotlivě, ale ne jako součást skupiny.',
        },
    },
};

export default cs;
